import React, {Component} from 'react';

class NotFound extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    return (
      <div className="stevie">
        <div className="stevie-info">
          <h1>This isn't good..</h1>
          <p>Oh no. Not good at all.</p>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/components/NotFound.jsx